import React, { useEffect, useState } from 'react';
import { Odd } from '../../../../models/Odd_response_model.tsx';
import { useBetContext } from '../../../../context/ParlayBetContext.tsx';
import { ParlaySelection } from '../../../../models/MyBetModel.tsx';
import { formatSpecialtyMarketLabel, getDisplayBetInfo, getBetSpecialtyMarketLabel } from '../../../../helpers/functions.tsx';
import BetLogo from '../BetLogo.tsx';
import { BetSlipTrashButton, SlipOddStepper } from '../BetSlipChrome.tsx';

interface ITeamOdd {
    bet: ParlaySelection
}

const TeamOdd = (props: ITeamOdd) => {

    const { bet } = props;
    const { deleteBet, updateExistingBet } = useBetContext();
    const [odd, setOdd] = useState(bet.odd);

    useEffect(() => {
        setOdd(bet.odd);
    }, [bet.odd]);

    const applyOdd = (newOdd: Odd) => {
        setOdd(newOdd);

        const updatedBet: ParlaySelection = {
            ...bet,
            odd: newOdd,
            id_selection: newOdd.id,
            betName: newOdd.name,
            marketName: newOdd.market
        };

        updateExistingBet(updatedBet);
    };

    const { name: displayBetName } = getDisplayBetInfo(bet);
    const oddsList = bet.odds?.length ? bet.odds : (odd ? [odd] : []);
    const marketLabel = getBetSpecialtyMarketLabel(bet) || formatSpecialtyMarketLabel(bet.marketName);

    return (
        <div className="sq-confirm__group-leg">
            <BetLogo bet={bet} className="sport-logos-modal" alt="" />
            <div className="sq-slip__pick-meta">
                <span className="sq-slip__pick-name">{displayBetName}</span>
                <span className="sq-slip__pick-market">{marketLabel || 'Parlay Selection'}</span>
            </div>
            <div className="sq-confirm__leg-odds">
                {oddsList.length > 0 && (
                    <SlipOddStepper
                        odds={oddsList}
                        value={odd?.id}
                        marketName={bet.marketName}
                        onSelect={applyOdd}
                    />
                )}
                <BetSlipTrashButton onClick={() => deleteBet(bet)} />
            </div>
        </div>
    );
};

export default TeamOdd;
